import { Mark, mergeAttributes, markInputRule, markPasteRule } from '@tiptap/core';
var starInputRegex = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))$/;
var starPasteRegex = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))/g;
var underscoreInputRegex = /(?:^|\s)((?:_)((?:[^_]+))(?:_))$/;
var underscorePasteRegex = /(?:^|\s)((?:_)((?:[^_]+))(?:_))/g;
var Italic = Mark.create({
  name: 'italic',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML: function parseHTML() {
    return [{
      tag: 'em'
    }, {
      tag: 'i',
      getAttrs: function getAttrs(node) {
        return node.style.fontStyle !== 'normal' && null;
      }
    }, {
      style: 'font-style=italic'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['em', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;

    return {
      setItalic: function setItalic() {
        return function (_ref2) {
          var commands = _ref2.commands;
          return commands.setMark(_this.name);
        };
      },
      toggleItalic: function toggleItalic() {
        return function (_ref3) {
          var commands = _ref3.commands;
          return commands.toggleMark(_this.name);
        };
      },
      unsetItalic: function unsetItalic() {
        return function (_ref4) {
          var commands = _ref4.commands;
          return commands.unsetMark(_this.name);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;

    return {
      'Mod-i': function ModI() {
        return _this2.editor.commands.toggleItalic();
      },
      'Mod-I': function ModI() {
        return _this2.editor.commands.toggleItalic();
      }
    };
  },
  addInputRules: function addInputRules() {
    return [markInputRule({
      find: starInputRegex,
      type: this.type
    }), markInputRule({
      find: underscoreInputRegex,
      type: this.type
    })];
  },
  addPasteRules: function addPasteRules() {
    return [markPasteRule({
      find: starPasteRegex,
      type: this.type
    }), markPasteRule({
      find: underscorePasteRegex,
      type: this.type
    })];
  }
});
export { Italic, Italic as default, starInputRegex, starPasteRegex, underscoreInputRegex, underscorePasteRegex };